import { RESOURCES } from './Resources'
import { newTranslationInstance } from '../services/TranslationHelpers'

const LibraryTranslationInstance = newTranslationInstance(RESOURCES)
LibraryTranslationInstance.init()
LibraryTranslationInstance.changeLanguage(
  localStorage?.getItem?.('language_setting') ?? 'en',
)

export default LibraryTranslationInstance
